import { render, staticRenderFns } from "./updateSettlement.vue?vue&type=template&id=931fdc24&"
import script from "./updateSettlement.vue?vue&type=script&lang=js&"
export * from "./updateSettlement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports